import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const commonAPI = createApi({
    reducerPath: 'commonAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        resetSystemRequestMapsAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESET_SYSTEM_REQUEST_MAPS_ACTION,
                method: 'POST',
                data,
            }),
        }),
        loadIntegrationConfiguration: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.LOAD_INTEGRATION_CONFIGURATION,
                method: 'POST',
            }),
        }),
        resetSystemPermissionsAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESET_SYSTEM_PERMISSIONS_ACTION,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useResetSystemRequestMapsActionMutation,
    useLoadIntegrationConfigurationMutation,
    useResetSystemPermissionsActionMutation,
} = commonAPI;
